export const categoryLabels: Record<string, string> = {
  clothing: 'Clothing',
  accessories: 'Accessories',
  'art-prints': 'Art Prints',
  'home-living': 'Home & Living',
}

export const stockColors: Record<string, string> = {
  'in-stock': 'bg-green-500',
  'low-stock': 'bg-amber-500',
  'out-of-stock': 'bg-red-500',
}

export const stockLabels: Record<string, string> = {
  'in-stock': 'In Stock',
  'low-stock': 'Low Stock',
  'out-of-stock': 'Out of Stock',
}
